import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { HttpService } from 'src/app/core/services/http/http.service';
import { CategoriesService } from 'src/app/pages/categories/categories.service';
import { AppState, selectCategoriesState } from 'src/store/reducers';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { Announcement } from 'src/store/actions/announcementActions';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {
  getCat: Observable<any>;
  constructor(private store: Store<AppState>, private categoriesServ: CategoriesService, private http: HttpService, private http_Client: HttpClient) {
    this.getCat = this.store.select(selectCategoriesState);
  }
  static formFields(value?) {
    return {
      'location': [value.location, Validators.required],
      'store_id': [value.store_id, Validators.required],
      'serial_number': [value.serial_number, Validators.required],
      'status': [value.status, Validators.required],
      'credentail_id': [value.credentail_id, Validators.required],
      'name' : [value.name , Validators.required]
    }
  }

  getStateOfCategories() {
    this.categoriesServ.dispatchCatAction();
    return this.getCat;
  }


  getStoresId() {
    return [
      { id: 1 },
      { id: 2 },
      { id: 3 },
    ]
  }



  getSelectedValue() {
    return [
      { name: 'Select Store' },
      { name: 'Select Location' },
    ]
  }

  getAllCredentials() {
    return this.http.query('get', 'credentail', {});
  }

  public getCities(): Observable<any> {
    return this.http_Client.get("./assets/i18n/cities.json")
  }

  getDoorLockById(id){
    return this.http.query('get', 'lock/'+id, {});
  }

  addLocker(newLocker) {
    return this.http.query('post', 'lock', {}, '', newLocker);
  }

  editLocker(newLocker , id) {
    return this.http.query('post', 'lock/'+id, {}, '', newLocker);
  }

  getLocker() {
    return this.http.query('get', 'store', {});
  }
}
